import { render, staticRenderFns } from "./FormExperienceEducation.vue?vue&type=template&id=12282cca&scoped=true&"
import script from "./FormExperienceEducation.vue?vue&type=script&lang=js&"
export * from "./FormExperienceEducation.vue?vue&type=script&lang=js&"
import style0 from "./FormExperienceEducation.vue?vue&type=style&index=0&id=12282cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12282cca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default})
